import { useClientFeature } from "@/hooks/useClientFeature";
import {
  resolveAnalyticsSurface,
  type AnalyticsSurface,
} from "@/utils/analyticsSurface";

export function useAnalyticsSurface(): AnalyticsSurface {
  const { isFeatureEnabled } = useClientFeature();

  return resolveAnalyticsSurface({
    hasAnalyticsV2: isFeatureEnabled("analyticsV2"),
  });
}
